import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/HomeView.vue'
import MainLayout from '@/views/layout/mainLayout.vue'
import Login from '@/views/login.vue'
import TrackCodeList from '@/views/TrackCodeList.vue'
import Profile from '@/views/Profile.vue'
import TrackCodeHistory from '@/views/TrackCodeHistory.vue'
import CameraReader from '@/views/cameraReader.vue'
import store from '@/store'
import ConfigPage from '@/views/ConfigPage.vue'
import MeasuringOut from '@/views/measuringOut.vue'
import Cargo from '@/views/CargoView.vue'
import PackagePage from '@/views/PackagePage.vue'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: MainLayout,
  redirect: '/',
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/',
    component: MainLayout, // энэ layout-тайгаа
    children: [
      { path: '/trackcodes', component: TrackCodeList }
    ]
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cargo',
    name: 'Cargo',
    component: Cargo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/trackCodeHistory',
    name: 'TrackCodeHistory',
    component: TrackCodeHistory,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/configPage',
    name: 'ConfigPage',
    component: ConfigPage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/measuringOut',
    name: 'MeasuringOut',
    component: MeasuringOut,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/camera',
    name: 'CameraReader',
    component: CameraReader,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/packagePage',
    name: 'PackagePage',
    component: PackagePage,
    meta: {
      requiresAuth: true
    }
  }
  ]
},
{
  path: '/login',
  name: 'Login',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: Login
}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth // Маршрут authentication шаардах эсэхийг шалгах
  const token = store.state.token // Хэрэглэгчийн authentication токен
  const user = store.state.user // Хэрэглэгчийн мэдээлэл

  if (requiresAuth && !token) {
    // Authentication шаардлагатай боловч токен байхгүй үед Login руу шилжүүлэх
    next({ name: 'Login' })
  } else if (!requiresAuth) {
    // Authentication шаардлагагүй бол шууд үргэлжлүүлэх
    next()
  } else {
    // Authentication шаардлагатай бөгөөд токен байгаа тохиолдолд хэрэглэгчийн мэдээллийг шалгах
    if (user) {
      if (user.lastName) {
        // Хэрэглэгчийн lastName байвал үргэлжлүүлэх
        next()
      } else {
        // lastName байхгүй бол AuthError руу шилжүүлэх
        next({ name: 'AuthError' })
      }
    } else {
      // Хэрэглэгчийн мэдээлэл байхгүй бол үргэлжлүүлэх
      next()
    }
  }
})
export default router
